import apiClient  from './Client';

export interface OrderDetails {
  orderID: number;
  quantity: number;
  price: number;
  productType: string;
  productName: string;
  productDesc: string;
  projectImageUrl: string;
  width: number;
  height: number;
}

export interface ShippingDetails {
  firstName: string;
  lastName: string;
  phoneNo: string;
  shippingAddress: string;
  country: string;
  state: string;
  city: string;
  zipCode: string;
  shippingMethod: string;
  trackingNumber: string;
  shippingCost: number;
  shippingDate: string; 
  deliveryDate: string; 
  shippingStatus: string;
}

export interface OrdersCountSummary  {
  allOrders: number,
  inprogress: number,
  delivered: number
}

export interface Order {
  orderID: number;
  orderDate: string; 
  orderStatus: string;
  paymentStatus: string;
  totalAmount: number;
  specialInstructions: string;
  orderDetailsList: OrderDetails[];
  shippingDetails: ShippingDetails;
  ordersCountSummary: OrdersCountSummary;
}

class MyOrderService {
    async CreateOrder(postData: any) { 
        try {
        const response = await apiClient.post(`/Order/create-order`, postData); 
        console.log(response);
        return response.data;
          
        } catch (err:any) {
          if(err.response.status===400)
          {
            console.log(err); 
            if(err.response.data.message==="Error in creating order")
              return "Failed to create order";
          }
            
        }
    };
    async GetMyOrders(status: string): Promise<Order[]> {
        console.log('GetMyOrders with productType');
        try {
            const response = await apiClient.get<Order[]>(`/Order/get-my-orders/${status}`);
            return response.data;
        } catch (err: any) {
            console.error(err);
            return [];
        }
      }
  
      // Delete an order by its ID
      async DeleteOrder(orderId: number) {    
          try {
              const response = await apiClient.delete(`/Order/${orderId}`);
              console.log(response);
              return response;
              
          } catch (error: any) {
              console.error('Error deleting order:', error);
              return error.response;
          }
      }

      async ReorderProduct(orderId: number): Promise<{ status: number; data: any } | string> {
        try {
            const response = await apiClient.post(`/Order/re-order/${orderId}`);
            console.log(response);
            return response; 
        } catch (err: any) {
            if (err.response?.status === 400) {
                console.log(err);
                if (err.response?.data?.message === "Error in creating order") {
                    return "Failed to create order";
                }
            }
            throw err;
        }
    }
    
      async GetShippingDetails(orderId: number) {
        try {
            const response = await apiClient.get(`/Order/get-shipping-details/${orderId}`);
            return response.data;
        } catch (err: any) {
            console.error(err);
            return [];
        }
      }
}

export default new MyOrderService()